<template>
  <section class="roadmap-section">
    <h2 class="section-title">
      <span class="highlight">2026</span>全球战略规划
    </h2>

    <div class="roadmap-card">
      <div
        v-for="(item, index) in roadmapItems"
        :key="index"
        class="roadmap-item"
      >
        <div class="roadmap-date">{{ item.date }}</div>
        <div class="roadmap-info">
          <p
            class="roadmap-title"
            :class="{ highlight: item.titleHighlight }"
          >
            {{ item.title }}
          </p>
          <p class="roadmap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ROADMAP_ITEMS } from "../config";

export default {
  data() {
    return {
      roadmapItems: ROADMAP_ITEMS,
    };
  },
};
</script>

<style lang="scss" scoped>
.roadmap-section {
  padding: 50px 30px 30px;
}

.section-title {
  margin: 0 0 30px;
  font-size: 50px;
  font-weight: normal;
  line-height: 1.3;
  color: #fff;
  text-align: center;

  .highlight {
    color: #7338ff;
  }
}

.roadmap-card {
  border-radius: 24px;
  background: #040a28;
  border: 1px solid rgba(192,192,192,0.4);
  overflow: hidden;
}

.roadmap-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 60px 50px;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(192,192,192,0.4);
  }
}

.roadmap-date {
  flex-shrink: 0;
  min-width: 72px;
  height: 72px;
  padding: 0 8px;
  border-radius: 16px;
  background: #7338ff;
  font-size: 28px;
  line-height: 72px;
  text-align: center;
  color: #fff;
}

.roadmap-info {
  flex: 1;
  min-width: 0;
}

.roadmap-title {
  margin: 0 0 10px;
  font-size: 28px;
  line-height: 1.4;
  color: #fff;

  &.highlight {
    color: #7338ff;
  }
}

.roadmap-desc {
  margin: 0;
  font-size: 24px;
  line-height: 1.5;
  color: #c0c0c0;
}
</style>
